import { ExceptionPanel } from "@swot/base-components";
import { normalizeUserSafeApiError } from "@cmts/api/apiErrorNormalizer.js";

export function CmtsSmartDataGridErrorState(props: { error: Error | string | unknown }) {
  const message = normalizeUserSafeApiError(props.error).userMessage || "Unable to render table.";
  return <ExceptionPanel title="Unable to render table" message={message} />;
}
